import {
  AUTH_COOKIE_REMEMBER_DAYS,
  AUTH_LOCAL_STORAGE_KEY,
  AUTH_TOKEN_HEADER_NAME,
  USER_EMAIL_HEADER_NAME,
} from 'src/app/project/shared/constants/auth.constants';
import { TTwoFactorAuthenticationState } from 'src/app/project/modules/auth/2fa/two-factor-authentication-state.model';

export type TUserAuth = {
  email?: string;
  token?: string;
  expiration?: string | null;
  remember?: boolean;
  twoFactorAuthentication?: TTwoFactorAuthenticationState;
};

let userAuth: TUserAuth = {
  email: undefined,
  token: undefined,
  expiration: null,
  remember: false,
};

export function getUserAuth(): TUserAuth {
  return userAuth;
}

export function setUserAuth(auth: TUserAuth): void {
  userAuth = auth;
  localStorage.setItem(AUTH_LOCAL_STORAGE_KEY, JSON.stringify(auth));
}

export function userAuthHasExpired(): boolean {
  const userFromLocalStorage = readUserAuthFromLocalStorage();

  if (userFromLocalStorage?.expiration) {
    if (+userFromLocalStorage.expiration < new Date().getTime()) {
      return true;
    }
  }
  return false;
}

export function readUserAuthFromLocalStorage(): TUserAuth {
  const userAuthFromLocalStorage = localStorage.getItem(AUTH_LOCAL_STORAGE_KEY);

  if (userAuthFromLocalStorage) {
    userAuth = JSON.parse(userAuthFromLocalStorage);
  } else {
    userAuth = {
      email: undefined,
      token: undefined,
    };
  }

  return userAuth;
}

export function clearUserAuth(): void {
  userAuth = {};

  localStorage.removeItem(AUTH_LOCAL_STORAGE_KEY);
}

export function getAuthHeaders(): Record<string, string | never> {
  userAuth = readUserAuthFromLocalStorage();

  if (userAuth?.token && userAuth?.email) {
    return {
      [AUTH_TOKEN_HEADER_NAME]: userAuth.token,
      [USER_EMAIL_HEADER_NAME]: userAuth.email,
    };
  }

  return {};
}

export function getExpirationDate(remember: boolean): string {
  const expirationDate = new Date();
  const daysToAdd = remember ? AUTH_COOKIE_REMEMBER_DAYS : 1;

  expirationDate.setDate(expirationDate.getDate() + daysToAdd);
  expirationDate.setHours(23, 59, 59, 999);

  return expirationDate.getTime().toString();
}

export function refreshAuthExpiration(): void {
  const current = readUserAuthFromLocalStorage();

  if (!current?.token) {
    return;
  }

  setUserAuth({ ...current, expiration: getExpirationDate(current.remember ?? false) });
}
